import React from "react";
import SignUp from "../../Authentication/SignUp";

export default function NewAccount() {
  return (
    <div>
      <SignUp redirect="false" />
    </div>
  );
}
